var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenance"},[_c('h1',[_vm._v("Hamarosan újra elérhetőek leszünk!")]),_c('div',[_c('p',[_vm._v(_vm._s(_vm.msg))]),_c('p',[_vm._v("— A Foglaljpalyat.hu csapata")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }